import {
  createFollowedChannel as publicCreateFollowedChannel,
  listFollowedChannels as publicListFollowedChannels,
} from './loyalty-socialmedia-v1-followed-channel-social-media.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onFollowedChannelCreated as publicOnFollowedChannelCreated } from './loyalty-socialmedia-v1-followed-channel-social-media.public.js';

export const createFollowedChannel: MaybeContext<
  BuildRESTFunction<typeof publicCreateFollowedChannel> &
    typeof publicCreateFollowedChannel
> = /*#__PURE__*/ createRESTModule(publicCreateFollowedChannel);
export const listFollowedChannels: MaybeContext<
  BuildRESTFunction<typeof publicListFollowedChannels> &
    typeof publicListFollowedChannels
> = /*#__PURE__*/ createRESTModule(publicListFollowedChannels);
/**
 * Triggered when an account follows a new channel.
 */
export const onFollowedChannelCreated: BuildEventDefinition<
  typeof publicOnFollowedChannelCreated
> &
  typeof publicOnFollowedChannelCreated = createEventModule(
  publicOnFollowedChannelCreated
);

export {
  Type,
  WebhookIdentityType,
} from './loyalty-socialmedia-v1-followed-channel-social-media.universal.js';
export {
  FollowedChannel,
  CreateFollowedChannelRequest,
  CreateFollowedChannelResponse,
  ListFollowedChannelsRequest,
  ListFollowedChannelsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  FollowedChannelCreatedEnvelope,
} from './loyalty-socialmedia-v1-followed-channel-social-media.universal.js';
export {
  TypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './loyalty-socialmedia-v1-followed-channel-social-media.universal.js';
